/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './ContributionLimitTable.scss';

import { object, string } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Content from 'services/Content';
import {
  today,
  DATE_DISPLAY_FORMAT,
  CURRENT_YEAR,
  PRIOR_YEAR
} from 'services/Dates';
import { Dollar } from 'components/shared/Text/Text';
import {
  getIRAContributionLimit,
  getIRAContributionPeriod
} from 'state/contributions/IRAContributionLimitSelectors';

class ContributionLimitTable extends React.Component {
  render() {
    const { contributionLimit, isWithinContributionPeriod } = this.props;
    const asOfDate = today(DATE_DISPLAY_FORMAT);

    return (
      <Fragment>
        <table className="table-component contribution-table">
          <thead>
            <tr className="contribution-limit-table-header">
              <TableHeaders
                isWithinContributionPeriod={isWithinContributionPeriod}
                isWithinEastContributionPeriod={contributionLimit}
              />
            </tr>
          </thead>
          <tbody>
            <TableRows
              contributionLimit={contributionLimit}
              isWithinContributionPeriod={isWithinContributionPeriod}
              asOfDate={asOfDate}
            />
          </tbody>
        </table>
        <ContributionFooter />
      </Fragment>
    );
  }
}

const TableHeaders = ({
  isWithinContributionPeriod,
  isWithinEastContributionPeriod
}) => {
  const { isWithinPriorYearContributionPeriod } = isWithinContributionPeriod;
  const { isWithinIRAPriorYearContributionPeriod } =
    isWithinEastContributionPeriod;

  return (
    <Fragment>
      <th />
      {(isWithinPriorYearContributionPeriod ||
        isWithinIRAPriorYearContributionPeriod) && <th>{PRIOR_YEAR}</th>}
      <th>{CURRENT_YEAR}</th>
    </Fragment>
  );
};

const TableRows = ({
  contributionLimit,
  isWithinContributionPeriod,
  asOfDate
}) => {
  const {
    currentYearMaximumLimit,
    currentYearContributionsSoFar,
    currentYearRemainingContributions,
    currentYearRemainingAutomaticPurchases,
    priorYearMaximumLimit,
    priorYearContributionsSoFar,
    priorYearRemainingContributions,
    priorYearRemainingAutomaticPurchases,
    isWithinIRAPriorYearContributionPeriod
  } = contributionLimit;
  const { isWithinPriorYearContributionPeriod } = isWithinContributionPeriod;

  return (
    <Fragment>
      <tr>
        <td>IRA annual contribution limit</td>
        {(isWithinPriorYearContributionPeriod ||
          isWithinIRAPriorYearContributionPeriod) && (
          <td>
            <Dollar element="span">{priorYearMaximumLimit}</Dollar>
          </td>
        )}
        <td>
          <Dollar element="span">{currentYearMaximumLimit}</Dollar>
        </td>
      </tr>
      <tr>
        <td>Your IRA contributions (as of {asOfDate})*</td>
        {(isWithinPriorYearContributionPeriod ||
          isWithinIRAPriorYearContributionPeriod) && (
          <td>
            <Dollar element="span">{priorYearContributionsSoFar}</Dollar>
          </td>
        )}
        <td>
          <Dollar element="span">{currentYearContributionsSoFar}</Dollar>
        </td>
      </tr>
      <tr>
        <td>Scheduled automatic IRA contributions</td>
        {(isWithinPriorYearContributionPeriod ||
          isWithinIRAPriorYearContributionPeriod) && (
          <td>
            <Dollar element="span">
              {priorYearRemainingAutomaticPurchases}
            </Dollar>
          </td>
        )}
        <td>
          <Dollar element="span">
            {currentYearRemainingAutomaticPurchases}
          </Dollar>
        </td>
      </tr>
      <tr>
        <td>Remaining IRA annual contribution limit</td>
        {(isWithinPriorYearContributionPeriod ||
          isWithinIRAPriorYearContributionPeriod) && (
          <td>
            <Dollar element="span">{priorYearRemainingContributions}</Dollar>
          </td>
        )}
        <td>
          <Dollar element="span">{currentYearRemainingContributions}</Dollar>
        </td>
      </tr>
    </Fragment>
  );
};

const ContributionFooter = () => {
  return (
    <div
      className="contribution-limit-footer"
      dangerouslySetInnerHTML={{
        __html: Content.iraContributionModalDisclosure
      }}
    />
  );
};

ContributionLimitTable.propTypes = {
  contributionLimit: object.isRequired,
  isWithinContributionPeriod: object.isRequired,
  asOfDate: string.isRequired
};

const mapStateToProps = (state) => ({
  contributionLimit: getIRAContributionLimit(state),
  isWithinContributionPeriod: getIRAContributionPeriod(state),
  requestStatus: state.requestStatus
});

export default connect(mapStateToProps)(ContributionLimitTable);
